import React from 'react';
import styles from '../../styles/DocumentManagement.module.css';

interface RingProps {
    overallStats: any;
}

const CircularProgressRing: React.FC<RingProps> = ({ overallStats }) => {
    const RING_RADIUS = 44;
    const RING_STROKE = 9;
    const RING_SIZE = (RING_RADIUS + RING_STROKE) * 2;
    const RING_CIRCUMFERENCE = 2 * Math.PI * RING_RADIUS;
    const rate = overallStats?.completionRate ?? 0;
    const ringOffset = RING_CIRCUMFERENCE - (rate / 100) * RING_CIRCUMFERENCE;
    const ringColor = getRingColor(rate);

    function getRingColor(rate: number): string {
        if (rate >= 90) return '#16a34a';
        if (rate >= 70) return '#d97706';
        return '#ef4444';
    }

    return (
        <div className={styles.overviewHeroRing}>
            <div className={styles.progressRingWrap}>
                <svg width={RING_SIZE} height={RING_SIZE} style={{ transform: 'rotate(-90deg)' }}>
                    {/* Track */}
                    <circle
                        cx={RING_SIZE / 2}
                        cy={RING_SIZE / 2}
                        r={RING_RADIUS}
                        fill="none"
                        stroke="#f3f4f6"
                        strokeWidth={RING_STROKE}
                    />
                    {/* Fill */}
                    <circle
                        cx={RING_SIZE / 2}
                        cy={RING_SIZE / 2}
                        r={RING_RADIUS}
                        fill="none"
                        stroke={ringColor}
                        strokeWidth={RING_STROKE}
                        strokeDasharray={RING_CIRCUMFERENCE}
                        strokeDashoffset={ringOffset}
                        strokeLinecap="round"
                        style={{ transition: 'stroke-dashoffset 0.6s ease' }}
                    />
                </svg>
                <div className={styles.progressRingLabel}>
                    <span className={styles.progressRingPercent}>{rate.toFixed(0)}%</span>
                    <span className={styles.progressRingSubtext}>complete</span>
                </div>
            </div>
            <span className={styles.overviewHeroRingLabel}>Overall</span>
        </div>
    );
}

export default CircularProgressRing;